import { render, staticRenderFns } from "./back.vue?vue&type=template&id=69fc949d&scoped=true&"
import script from "./back.vue?vue&type=script&lang=js&"
export * from "./back.vue?vue&type=script&lang=js&"
import style0 from "./back.vue?vue&type=style&index=0&id=69fc949d&scoped=true&lang=css&"
import style1 from "./back.vue?vue&type=style&index=1&id=69fc949d&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fc949d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69fc949d')) {
      api.createRecord('69fc949d', component.options)
    } else {
      api.reload('69fc949d', component.options)
    }
    module.hot.accept("./back.vue?vue&type=template&id=69fc949d&scoped=true&", function () {
      api.rerender('69fc949d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/back.vue"
export default component.exports